/**
 * @winrt
 */
export var AnnotationState;
(function (AnnotationState) {
    AnnotationState[AnnotationState["Undefined"] = 0] = "Undefined";
    //only dealt with on server side
    AnnotationState[AnnotationState["Created"] = 10] = "Created";
    AnnotationState[AnnotationState["Sent"] = 20] = "Sent";
    AnnotationState[AnnotationState["Duplicated"] = 30] = "Duplicated";
    //dealt with on client side and server side
    AnnotationState[AnnotationState["Seen"] = 40] = "Seen";
    AnnotationState[AnnotationState["Tried"] = 50] = "Tried";
    AnnotationState[AnnotationState["Kept"] = 60] = "Kept";
    AnnotationState[AnnotationState["Rejected"] = 70] = "Rejected";
})(AnnotationState || (AnnotationState = {}));
//# sourceMappingURL=annotations.js.map